import { ProjectDto } from 'tdc-web-backend/projects/schemas';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useGetMany from '../../../../../utils/hooks/crud-hooks/useGetMany';
import useAuth from '../../../../../utils/hooks/useAuth';
import useMode from '../../../../../utils/hooks/useMode';
import { EnumMode } from '../../../../../utils/context/Mode.context';
import Link from '../../../../../components/link/Link';
import EmptyCard from './components/EmptyCard';
import E2EProjectCard from './components/E2EProjectCard';

const ProjectList = () => {
  const { t } = useTranslation();
  const {
    authData: { userData: user },
  } = useAuth();
  const { mode } = useMode();

  const { data: projectResponse, isLoading } = useGetMany<ProjectDto>({
    enabled: !!user,
    resource: `/projects?limit=3&${mode === EnumMode.Client ? 'buyer' : 'seller'}=${
      user?.membership?.company
    }`,
  });

  const projects = projectResponse?.data.results ?? [];
  return (
    <Stack width="100%" spacing={2}>
      <Stack width="100%" direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="heading3" color="primaryDark.500">
          {t('common.projects')}
        </Typography>
        <Link
          to="/dashboard/end-to-end"
          sx={{
            display: 'flex',
            justifyContent: 'end',
            pointerEvents: projects.length <= 1 ? 'none' : 'inherit',
          }}
        >
          <Typography
            variant="heading4"
            color={projects.length <= 1 ? 'primaryLight.200' : 'primaryLight.500'}
          >
            {t('common.viewAll')}
          </Typography>
        </Link>
      </Stack>
      {isLoading || (
        <Stack gap={2} width="100%" direction={{ xs: 'column', lg: 'row' }}>
          {projects.map((project) => (
            <E2EProjectCard key={project.id} project={project} sxCard={{ maxWidth: '440px' }} />
          ))}
          {projects.length === 0 && <EmptyCard />}
        </Stack>
      )}
    </Stack>
  );
};

export default ProjectList;
